import { render } from "./TheSettings.vue?vue&type=template&id=f3db931e&scoped=true"
import script from "./TheSettings.vue?vue&type=script&lang=js"
export * from "./TheSettings.vue?vue&type=script&lang=js"

import "./TheSettings.vue?vue&type=style&index=0&id=f3db931e&scoped=true&lang=css"

import exportComponent from "/home/cyrill/Projects/kmapper/repos/1mal1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3db931e"]])

export default __exports__